export default {
    getintegracoes: state => state.integracoes,
    getagendamentoSelecionado: state => state.agendamentoSelecionado,
    getRamais: state => state.ramais,
    getTroncos: state => state.troncos,
    getTags: state => state.tags,
    getIntegracaoSegware: state => state.segware,
    getAudios: state => state.audios,
    getIa: state => state.ia,
    getOperadores: state => state.operador,
  }
  